const ENUM_VALUE_TYPE = 'enum';
const STRING_VALUE_TYPE = 'string';
const ARRAY_VALUE_TYPE = 'array';
const BOOLEAN_VALUE_TYPE = 'boolean';
const NUMBER_VALUE_TYPE = 'number';

const CELL_LAYOUT_TYPE = 'cell';
const LABELLED_LAYOUT_TYPE = 'labelled';
const FULL_LAYOUT_TYPE = 'full';

export {
  ENUM_VALUE_TYPE,
  ARRAY_VALUE_TYPE,
  STRING_VALUE_TYPE,
  BOOLEAN_VALUE_TYPE,
  NUMBER_VALUE_TYPE,
  CELL_LAYOUT_TYPE,
  LABELLED_LAYOUT_TYPE,
  FULL_LAYOUT_TYPE,
};
